const pickup_header = [
            { title: "Tires, wheels, stem caps", description: "Inflation, leaks, damage, wear" },
            { title: "Alternator", description: "Function" },
            { title: "Body", description: "Damage" },
            { title: "Brakes, parking", description: "Function" },
            { title: "Brakes, service", description: "Function" },
            { title: "Clutch", description: "Function, damage" },
            { title: "Drive line", description: "Function, damage" },
            { title: "Engine", description: "Condition" },
            { title: "Exhaust", description: "Function, condition" },
            { title: "Frame and assembly", description: "Damaged frame" },
            { title: "Front axle, A-frame", description: "Damage or deterioration" },
            { title: "Fuel cap", description: "Present, damage, leaks" },
            { title: "Guages", description: "Function, damage" },
            { title: "Hitch", description: "Damage or deterioration" },
            { title: "Lights, head, tail", description: "Function, damage" },
            { title: "Lights, turn indicators", description: "Function, damage" },
            { title: "Muffler", description: "Condition" },
            { title: "Rear end", description: "Condition" },
            { title: "Starter", description: "Function, damage" },
            { title: "Steering mechanism", description: "Condition" },
            { title: "Suspension system", description: "Condition" },
            { title: "Tires", description: "Inflation, tread, damage" },
            { title: "Tire chains", description: "Damage or deterioration" },
            { title: "Transimission", description: "Condition" },
            { title: "Wheels, rims, lugs", description: "Loose, missing, damaged or ineffective wheel faster" },
            { title: "Engine oil", description: "Fluid level" },
            { title: "Engine coolant", description: "Fluid level" },
            { title: "Steering oil tank", description: "Fluid level, damage, leaks" },
            { title: "Break fluid level", description: "Fluid level" },
            { title: "Transmission oil tank", description: "Fluid level, damage, leaks" },
            { title: "Washer fluid", description: "Fluid level" },
            { title: "Battery", description: "Charge, damage" },
            { title: "Radiator", description: "Blockage, leaks" },
            { title: "All hoses", description: "Cracks, wear spots, leaks" },
            { title: "All belts", description: "Tension, wear, cracks" },
            { title: "Overall under the hood", description: "Trash or dirt buildup, leaks" },
            { title: "Fire extinguisher", description: "Charge, damage" },
            { title: "Flags, flares, fuses", description: "Present, damage" },
            { title: "Reflective triangles", description: "Present, damage" },
            { title: "Reflectors", description: "Present, damage" },
            { title: "Spare bulbs and Fuses", description: "Present, damage" },
            { title: "Defroster and heater", description: "Condition, function" },
            { title: "Seat", description: "Adjustment, able to reach pedals" },
            { title: "Seat belt and mounting", description: "Damage, wear, adjustment, age" },
            { title: "Horn, backup alarm, lights", description: "Proper function" },
            { title: "Mirrors", description: "Damage, adjust for best visibility" },
            { title: "Recirculation cab air filter", description: "Dirt, dust" },
            { title: "Gauges, indicators, switches, controls", description: "Damage, function" },
            { title: "Overall cab interior", description: "Cleanliness" },
        ]

export default pickup_header;